import { compose, withState } from 'recompose';

import StampView from './StampView';

export default compose(
  withState('statusStamp', 'setStamp', false),
)(StampView);
